import React from 'react';

import { IconButton } from '@mui/material';

import { DocumentDownloader } from './DocumentDownloader';
import DocumentDownloadIcon from '../../_assets/svg/DocumentDownloadIcon.svg';

interface DocumentDownloadButtonProps {
  readonly id: string;
  readonly name: string;
  readonly type: string;
}

/**
 * The download control every documents listing puts in its "Download" column.
 *
 * It is an `IconButton`, not the app's `Button`: `Button` renders MUI's button
 * root, which carries a 64px `min-width` the theme never overrides. The icon is
 * 2rem, so the button padded it out to 64px and centred it -- leaving the glyph
 * ~16px right of the cell's content origin, while the column header sits at the
 * origin. That offset is what FIR-20994 reported as the values not lining up
 * with their header. `IconButton` has no `min-width` and sizes to its content,
 * which is why the Delete column beside it was never misaligned.
 */
export const DocumentDownloadButton = ({
  id,
  name,
  type,
}: DocumentDownloadButtonProps) => (
  <DocumentDownloader id={id} name={name} type={type}>
    {({ handleDocumentDownload }) => (
      <IconButton
        size="small"
        aria-label={`Download ${name}`}
        onClick={handleDocumentDownload}
      >
        <DocumentDownloadIcon style={{ width: '2rem', height: '2rem' }} />
      </IconButton>
    )}
  </DocumentDownloader>
);
